import { DTO__special_collections_info } from '@shared/dto/collection/DTO__special_collections_info';
import { STATE__collections } from '../STATE__collections';

export function get_or_create_special_collection_info_by_workspace_id(state: STATE__collections, workspace_id: string) {
  let out = state.special_collections_info_map.get(workspace_id);

  if (!out) {
    out = new DTO__special_collections_info();
    out.workspace_id = workspace_id;

    state.special_collections_info_map.set(workspace_id, out);
  }

  return out;
}
